import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../../shared/';
import { User } from '../../models/user';
import { ColDef, FirstDataRenderedEvent, GridOptions } from 'ag-grid-community';
import { DateFormatPipe } from 'ngx-moment';
import { ConfigService } from '../../shared/services/config.service';
import { dateComparator } from '../../shared/helpers/DateComparator';
import { filterDateComparator } from '../../shared/helpers/FilterDateComparator';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { FlexModule } from '@angular/flex-layout';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  providers: [UserService, DateFormatPipe],
  standalone: true,
  imports: [AgGridModule, FlexModule, MatButton]
})
export class UserComponent implements OnInit {
  users: Array<User>;
  columns: ColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      sort: 'asc',
      sortable: true,
      filter: true
    },
    {
      headerName: 'Email',
      field: 'email',
      sortable: true,
      filter: 'email'
    },
    {
      headerName: 'Created',
      field: 'created_at',
      width: 180,
      sortable: true,
      valueGetter: (params) => {
        return this.dateFormatPipe.transform(
          params.data['created_at'],
          ConfigService.dates.shortDateTimeFormat
        );
      },
      comparator: dateComparator,
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: filterDateComparator
      }
    }
  ];

  gridOptions: GridOptions = {
    rowSelection: 'single',
    headerHeight: 45,
    onFirstDataRendered(event: FirstDataRenderedEvent<any>) {
      event.api.autoSizeAllColumns();
    }
  };

  constructor(
    private userService: UserService,
    private router: Router,
    private dateFormatPipe: DateFormatPipe
  ) {}

  ngOnInit() {
    this.userService.getAll().subscribe(
      (response) => {
        this.users = response;
        this.gridReady();
      },
      (error) => {}
    );
  }

  public addUser() {
    this.router.navigate(['/users/add']);
  }

  public onCellClicked($event: any) {
    this.router.navigate(['/users', $event.data.id]);
  }

  gridReady() {
    // if (this.gridOptions.api) {
    //   this.gridOptions.columnApi.autoSizeAllColumns();
    // }
  }
}
